import { __decorate } from "tslib";
import { isEmpty } from 'lodash';
import { Component, Vue, Prop, Model } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
    value;
    options;
    multiple;
    placeholder;
    disabled;
    collapseTags;
    onChange(value) {
        this.$emit('onLabelChange', this.$refs.cascaderAddr.getCheckedNodes());
        this.$emit('onValueChange', isEmpty(value) && this.multiple ? [] : value);
    }
    getVisibleChange(status) {
        this.$emit('visible-change', status);
    }
    remove(tag) {
        this.$emit('remove-value', tag);
    }
};
__decorate([
    Model('change')
], default_1.prototype, "value", void 0);
__decorate([
    Prop()
], default_1.prototype, "options", void 0);
__decorate([
    Prop()
], default_1.prototype, "multiple", void 0);
__decorate([
    Prop()
], default_1.prototype, "placeholder", void 0);
__decorate([
    Prop({ default: false, type: Boolean })
], default_1.prototype, "disabled", void 0);
__decorate([
    Prop({ default: false, type: Boolean })
], default_1.prototype, "collapseTags", void 0);
default_1 = __decorate([
    Component({
        name: 'cascader-select',
        i18n: {
            messages: { en: {} },
        },
    })
], default_1);
export default default_1;
